
























import {Component, Emit, Prop} from "vue-property-decorator";
import AsiCard from "./AsiCard.vue";
import {Icon} from "@/helpers/icons";

@Component({
	components: {AsiCard}
})
export default class AsiCardDetail extends AsiCard {

	@Prop({type: String, default: Icon.edit})
	public actionButtonIcon!: string;

	@Prop({type: Boolean, default: false})
	public prependUnwrapped!: boolean;

	@Prop({type: Boolean, default: false})
	public appendUnwrapped!: boolean;

	@Prop({type: Boolean, default: true})
	public showActionButton!: boolean;

	@Prop({type: Boolean, default: false})
	public actionButtonDisabled!: boolean;

	protected icons = Icon;

	private get hasActionButtonListener(): boolean {
		return !!this.$listeners.actionButtonClicked;
	}

	private get hasPrepend(): boolean {
		return !!this.$slots['prepend'];
	}

	private get hasAppend(): boolean {
		return !!this.$slots['append'];
	}

	@Emit('actionButtonClicked')
	public actionButtonClicked(event: Event): Event {
		return event;
	}

}
